<template>
  <div id="app" :class="{ 'fixed-border': inIframe, 'kiosk-specific': isKiosk, 'overview-show': showOverview, 'with-products': withProducts, 'bubble-closer': $root.bubble, 'full-closer': $root.full }">
    <div class="fixed-full"></div>
    <Conversation :overview.sync="showOverview" ref="conversation" />
    <transition name="fade">
      <!-- <Overview :show.sync="showOverview" v-if="mount" /> -->
    </transition>
    <MyButton v-if="isKiosk" class="btn-restart" @click="restart" @dblclick="rerestart" :icon="restartIcon" color="#E2260F">{{removeEmoji($root.__('Herstart'))}}</MyButton>

    <transition name="fade">
      <ProductDetail :show.sync="$root.productDetail" v-if="$root.productDetail" :p="$root.productDetail" />
    </transition>
    <ShoppingCart :items="$root.user.cartItems" v-if="$root.cart" />
    <button type="button" class="iframe-closer" @click="destr">
      <div class="iframe-closer-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path fill="#fff" d="M14.1279 1.41L12.7179 0L7.12793 5.59L1.53793 0L0.12793 1.41L5.71793 7L0.12793 12.59L1.53793 14L7.12793 8.41L12.7179 14L14.1279 12.59L8.53793 7L14.1279 1.41Z"/></svg></div>
    </button>
  </div>
</template>

<script>
import Conversation from './components/Conversation.vue'
import ShoppingCart from './components/ShoppingCart.vue'
import MyButton from './components/MyButton.vue'
import { theme } from './themes.js'
import { removeEmoji } from './util.js'

if (theme.background) {
  function bgimg (str) {
    return str && '.fixed-full{background-image:url(' + str + ')}' || ''
  }
  const mobile = document.createElement('style')
  mobile.appendChild(document.createTextNode(`.fixed-full{background:${theme.background};background-position: bottom left;background-repeat: no-repeat;}
${bgimg(theme.backgroundImage)}
@media only screen and (max-width: 999px){${bgimg(theme.mobileBackground)}}
${theme.style||''}`))
  document.head.appendChild(mobile)
}

export default {
  components: {
    Conversation,
    Overview: () => import('./components/Overview.vue' /* webpackChunkName: "0" */),
    ShoppingCart,
    MyButton,
    ProductDetail: () => import('./components/ProductPage.vue' /* webpackChunkName: "0" */),
  },
  data() {
    return {
      mount: false,
      showOverview: false,
      showProductDetail: false,
      restartIcon: '<svg class="icon-svg" viewBox="-1 -1 24 24" xmlns="http://www.w3.org/2000/svg"><path class="fill-fg" fill="white" d="M11,4C13.05,4 15.09,4.77 16.65,6.33C19.78,9.46 19.77,14.5 16.64,17.64C14.81,19.5 12.3,20.24 9.91,19.92L10.44,17.96C12.15,18.12 13.93,17.54 15.24,16.23C17.58,13.89 17.58,10.09 15.24,7.75C14.06,6.57 12.53,6 11,6V10.58L6.04,5.63L11,0.68V4M5.34,17.65C2.7,15 2.3,11 4.11,7.94L5.59,9.41C4.5,11.64 4.91,14.39 6.75,16.23C7.27,16.75 7.87,17.16 8.5,17.45L8,19.4C7,19 6.12,18.43 5.34,17.65Z"></path></svg>'
    }
  },
  computed: {
    inIframe() {
      return window !== window.top && !this.$root.kiosk
    },
    isKiosk() {
      return this.$root.kiosk
    },
    withProducts () {
      const { messages } = this.$root
      const last = messages[messages.length - 1]
      const last2 = messages[messages.length - 2]
      return (last && (!!last.products || !!last.categories)) || (last2 && (!!last2.products || !!last2.categories))
    }
  },
  methods: {
    destr () {
      if (this.showOverview === 'top') {
        this.showOverview = 1
      } else if (this.showOverview) {
        this.showOverview = 0
      } else {
        this.$root.track({
          event_type: 'user_interaction',
          interaction_type: 'stop-session',
          page_type: 'dreambuddy'
        })
        window.top.postMessage('destroy', '*')
      }
    },
    restart() {
      this.$emit('update:show', 0)
      this.$root.restart()
    },
    rerestart() {
      this.restart()
      window.location.reload(true)
    },
    removeEmoji
    /*
    hideOverview () {
      if (this.withProducts && this.showOverview) {
        this.showOverview = 0
      }
    }
    */
  },
  mounted () {
    window.top.postMessage('mounted', '*')
    setTimeout(() => {
      this.mount = true
    }, 1000)
  },
  watch: {
    /*
    showOverview (val, old) {
      if (val && !old) {
        this.$refs.conversation.$el.addEventListener('mousedown', this.hideOverview, { passive: true })
        this.$refs.conversation.$el.addEventListener('scroll', this.hideOverview, { passive: true })
        this.$refs.conversation.$el.addEventListener('touchstart', this.hideOverview, { passive: true })
      } else {
        this.$refs.conversation.$el.removeEventListener('mousedown', this.hideOverview)
        this.$refs.conversation.$el.removeEventListener('scroll', this.hideOverview)
        this.$refs.conversation.$el.removeEventListener('touchstart', this.hideOverview)
      }
    }*/
  }
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}
* {
  box-sizing: inherit;
}
#app {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.fixed-full {
  position: fixed;
  z-index: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
@media (min-width: 1024px) {
  .fixed-border .fixed-full {
    border-radius: 10px;
  }
}

.iframe-closer {
  display: none;
  position: fixed;
  z-index: 12;
  top: 0;
  right: 0;
  margin: 0;
  border: 0;
  padding: 8px;
  background: none;
  transition: transform .2s;
}
.iframe-closer:hover {
  transform: scale(1.25);
  transition: all .2s;
}
.iframe-closer:focus {
  opacity: .5;
  outline: none;
}
.iframe-closer-icon {
  background: rgba(0, 0, 0, .2);
  border-radius: 50%;
  padding: 13px;
}
.iframe-closer-icon>svg {
  display: block;
  margin: 0;
}
.iframe-closer .fill-fg {
  fill: white;
}

/* Allow user to close overview */
@media (max-width: 1000px) {
  .overview-show .iframe-closer {
    display: block;
  }
}
/* Allow user to close fullscreen bubble */
.bubble-closer .iframe-closer {
  display: block;
}
/* There is a closer in the bottom right */
@media (min-width: 400px) and (max-width: 400px) {
  .bubble-closer .iframe-closer {
    display: none;
  }
}
/* Allow user to close fullscreen cadeaukiezer */
.full-closer .iframe-closer {
  display: block;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0!important;
}
.slide-enter-active, .slide-leave-active {
  transition: transform .3s;
}
.slide-enter, .slide-leave-to {
  transform: translateY(-100%);
}
.kiosk-specific {
  font-size: 1.2em;
}
.kiosk-specific .spacer-top {
  height: calc(50vh - 229px)
}
.btn-restart {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 1em;
}
.hidden {
  display: none;
}
</style>
